import React from 'react';
import { Box, Typography } from '@mui/material';

export interface DividerLabelProps {
    /**
     * Testo opzionale. Se omesso, mostra solo la linea orizzontale bianca.
     */
    label?: React.ReactNode;
    my?: number
}

const barColor = "rgb(100,100,100)"

export const DividerLabel: React.FC<DividerLabelProps> = ({ label, my = 2 }) => {
    // Caso 1: Nessuna label, renderizza solo la linea bianca su tutta la larghezza
    if (!label) {
        return (
            <Box
                sx={{
                    width: '100%',
                    height: '1px',
                    backgroundColor: barColor, // Linea bianca
                    my,
                }}
            />
        );
    }

    // Caso 2: Label presente. Testo a sinistra, linea a destra.
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                my
            }}
        >
            <Typography
                sx={{
                    color: 'white', // Testo bianco
                    mr: 2,          // Margine destro per distanziare la label dalla linea
                    whiteSpace: 'nowrap', // Impedisce al testo di andare a capo
                }}
            >
                {label}
            </Typography>

            {/* La linea che riempie lo spazio rimanente a destra */}
            <Box
                sx={{
                    flexGrow: 1, // Prende tutta la larghezza rimanente
                    height: '1px',
                    backgroundColor: barColor, // Linea bianca
                }}
            />
        </Box>
    );
};

export default DividerLabel;